import React, { useEffect, useState } from "react";
import playstoreImg from "../Logos/playstore.png";
import appstoreimg from "../Logos/app-store.png";

const AppDownloadPopup = () => {
  const [open, setOpen] = useState(false);

useEffect(() => {
  const today = new Date().toISOString().split("T")[0];

  const popupData = JSON.parse(
    localStorage.getItem("app_popup_daily_count") || "{}"
  );

  let count = 0;

  // Reset count if it's a new day
  if (popupData.date === today) {
    count = popupData.count || 0;
  }

  // Show only if displayed less than 2 times today
  if (count < 2) {
    const timer = setTimeout(() => {
      setOpen(true);

      localStorage.setItem(
        "app_popup_daily_count",
        JSON.stringify({
          date: today,
          count: count + 1,
        })
      );
    }, 2500);

    return () => clearTimeout(timer);
  }
}, []);

const handleClose = () => {
  setOpen(false);
};
  if (!open) return null;

  return (
    <div className="app-popup-overlay">
      <div className="app-popup-card">

        {/* Close */}
        <button
          className="app-popup-close"
          onClick={handleClose}
        >
          ✕
        </button>

        {/* Glow */}
        <div className="app-popup-glow" />

        {/* Content */}
        <div className="app-popup-content">

          <div className="app-popup-badge">
            📱 MOBILE APP AVAILABLE
          </div>

          <h2 className="app-popup-title">
            Download Our App
          </h2>

          <p className="app-popup-sub">
            For a faster experience and never miss exclusive offers & health deals.
          </p>


        <div className="app-popup-actions">

        <a
            href="https://play.google.com/store/apps/details?id=com.ayuja.app&hl=en_IN"
            target="_blank"
            rel="noopener noreferrer"
            className="store-btn"
        >
            <span className="store-label">
            For Android
            </span>

            <img
            src={playstoreImg}
            alt="Google Play"
            />
        </a>

        <a
            href="https://apps.apple.com/in/app/ayuja/id6758427368"
            target="_blank"
            rel="noopener noreferrer"
            className="store-btn"
        >
            <span className="store-label">
            For iPhone / iPad
            </span>

            <img
            src={appstoreimg}
            alt="App Store"
            />
        </a>

        </div>
        </div>
      </div>

      <style>{`
        .app-popup-overlay{
          position:fixed;
          inset:0;
          background:rgba(0,0,0,0.55);
          backdrop-filter:blur(6px);
          z-index:99999;
          display:flex;
          align-items:center;
          justify-content:center;
          padding:20px;
          animation:fadeIn .25s ease;
        }

        .app-popup-card{
          position:relative;
          width:100%;
          max-width:420px;
          overflow:hidden;
          border-radius:28px;
          background:
            linear-gradient(
              135deg,
              rgba(0,109,119,0.96) 0%,
              rgba(0,169,181,0.88) 100%
            );
          border:1px solid rgba(255,255,255,0.15);
          box-shadow:
            0 20px 60px rgba(0,0,0,0.35);
        }

        .app-popup-glow{
          position:absolute;
          width:240px;
          height:240px;
          border-radius:50%;
          background:rgba(255,255,255,0.12);
          filter:blur(60px);
          top:-80px;
          right:-50px;
        }

        .app-popup-content{
          position:relative;
          padding:34px 28px;
          text-align:center;
          z-index:2;
        }

        .app-popup-close{
          position:absolute;
          top:14px;
          right:14px;
          width:36px;
          height:36px;
          border:none;
          border-radius:50%;
          background:rgba(255,255,255,0.14);
          color:#fff;
          font-size:16px;
          cursor:pointer;
          z-index:5;
        }

        .app-popup-close:hover{
          background:rgba(255,255,255,0.22);
        }

        .app-popup-badge{
          display:inline-flex;
          align-items:center;
          gap:8px;
          padding:8px 16px;
          border-radius:999px;
          background:rgba(255,255,255,0.14);
          border:1px solid rgba(255,255,255,0.18);
          color:#CFFAFE;
          font-size:12px;
          font-weight:700;
          margin-bottom:18px;
        }

        .app-popup-title{
          color:#fff;
          font-size:25px;
          line-height:1.1;
          margin:0;
          font-weight:800;
        }

        .app-popup-sub{
          margin-top:14px;
          color:rgba(255,255,255,0.82);
          font-size:15px;
          font-weight:500;
          line-height:1.6;
        }

        .app-popup-actions{
            margin-top:28px;
            display:flex;
            justify-content:center;
            align-items:stretch;
            gap:16px;
            flex-wrap:wrap;
            }

        .store-btn{
            display:flex;
            flex-direction:column;
            align-items:center;
            justify-content:center;
            text-decoration:none;
            min-width:140px;
            transition:all .25s ease;
            }

        .store-btn:hover{
            transform:translateY(-3px) scale(1.03);
            }

        .store-label{
            color:#ffffff;
            font-size:17px;
            font-weight:700;
            margin-bottom:18px;
            letter-spacing:.3px;
            opacity:.92;
            }

        .store-btn img{
            width:100px;
            max-width:42vw;
            height:auto;
            display:block;
            object-fit:contain;
            border-radius:14px;
            filter:drop-shadow(
                0 8px 20px rgba(0,0,0,0.22)
            );
            }



        @keyframes fadeIn{
          from{
            opacity:0;
          }
          to{
            opacity:1;
          }
        }
          /* Tablet */
                @media (max-width:768px){

                .app-popup-actions{
                    gap:14px;
                }

                .store-btn img{
                    width:145px;
                }
                }

                /* Mobile */
                @media (max-width:520px){

                .app-popup-actions{
                    flex-direction:column;
                    align-items:center;
                    gap:18px;
                }

                .store-btn{
                    width:100%;
                }

                .store-btn img{
                    width:80px;
                    max-width:72vw;
                }

                .store-label{
                    font-size:12px;
                }
                }

        @media (max-width:600px){

          .app-popup-content{
            padding:28px 20px;
          }

          .app-popup-title{
            font-size:28px;
          }

          .app-popup-sub{
            font-size:14px;
          }
        }
      `}</style>
    </div>
  );
};

export default AppDownloadPopup;